import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
// Included apps

import ChatWidget from '../apps/chat';

const { theme, chatSystem, chatHubUrl, chatApiKey, chatBotName } = document.querySelector('body').dataset;

Modal.setAppElement('#chatContainer');
ReactDOM.render(
  <ChatWidget
    apiKey={chatApiKey}
    url={chatHubUrl}
    theme={theme}
    botName={chatBotName}
    hideOpener={chatSystem !== 'enabled'}
    proactive={chatSystem === 'enabled'}
  />,
  document.getElementById('chatContainer'),
);
